import React from "react";
import { List } from "react-window";
import { ListItem } from "./components";
import { virtualizedTypes } from "./duck";

const VirtualizedList: React.FC<virtualizedTypes.VirtualizedListProps> =
  React.memo(({ data = [] }) => {
    const listRef = React.useRef<any>(null);
    const sizeMap = React.useRef<virtualizedTypes.SizeMap>({});

    const setSize = React.useCallback<virtualizedTypes.SetSize>(
      (index, height) => {
        sizeMap.current = { ...sizeMap.current, [index]: height };
        listRef.current.resetAfterIndex(index);
      },
      [],
    );

    const getItemSize = React.useCallback<virtualizedTypes.GetItemSize>(
      (index) => sizeMap.current[index] || 42,
      [],
    );

    const itemCount = React.useMemo(() => data?.length || 0, [data?.length]);

    return (
      <List
        rowProps={{ data }}
        listRef={listRef}
        rowCount={itemCount}
        style={{ height: 400, width: "100%" }}
        rowHeight={getItemSize}
        rowComponent={(rowProps) => {
          const item = data?.[rowProps.index] || {};

          return (
            <ListItem
              index={rowProps.index}
              item={item}
              setSize={setSize}
              style={rowProps.style}
            />
          );
        }}
      />
    );
  });

export default VirtualizedList;
